// Copyright (c) 2017 Deere & Company

import './claim-history-panel.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Accordion from '../../../shared/components/accordion';
import Claim from '@deere/cps-it.warranty-model-factory/lib/claim';
import ClaimDetails from './claim-details';
import DownloadToExcelForPanel from '../../../shared/components/download-to-excel-for-panel';
import {FormattedMessage} from 'react-intl';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildNumber} from '../../../shared/services/build-number';
import {exportToExcel} from '../../../shared/services/export-to-excel';
import {secure} from '../../../shared/components/security-wrapper/secure';

class ClaimHistoryPanel extends Component {

    componentWillMount() {

        this.props.actions.readClaimTypes();

    }

    render() {

        const claimHistoryPanelBody = this.props.claims.map(claim =>
            <ClaimDetails
                claim={claim}
                key={claim.id}
            />
        );

        const claimHistoryPanelTitle = (
            <span className='claim-panel-title'>
                <FormattedMessage
                    id='CLAIM_HISTORY_WITH_COUNT'
                    values={{
                        count: buildNumber(this.props.claims.length)
                    }}
                />
            </span>
        );

        const downloadToExcelEl = this.props.claims.length ? (
            <DownloadToExcelForPanel onDownload={() => exportToExcel(`/api/products/${this.props.pin}/claims?export=EXCEL&language=${this.context.user.getLocale()}`)}/>) : null;

        return (
            <Accordion
                accordionId='claim-history-panel-accordion'
                body={claimHistoryPanelBody}
                isExpanded={this.props.isExpanded}
                onClick={this.props.onClick}
                secondaryHeaderNode={downloadToExcelEl}
                title={claimHistoryPanelTitle}
            />
        );

    }

}

ClaimHistoryPanel.displayName = 'ClaimHistoryPanel';
ClaimHistoryPanel.propTypes = {
    actions: PropTypes.object.isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(Claim)).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired
};
ClaimHistoryPanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default secure('PRT', 'PRT_CLAIM_HISTORY')(ClaimHistoryPanel);



// WEBPACK FOOTER //
// ./src/product/details/components/claim-history-panel.js